import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useTranslation } from '../../i18n';
import { usePlatformLabel } from '../../hooks/usePlatformLabel';
import styles from './Charts.module.css';

const COLORS = [
  'var(--accent)',
  'var(--chart-2, #FFB800)',
  'var(--chart-3, #FF3333)',
  'var(--chart-4, #00FFFF)',
  'var(--chart-5, #7B68EE)',
  'var(--chart-6, #FF69B4)',
  'var(--chart-7, #32CD32)',
  'var(--chart-8, #FF8C00)',
  'var(--chart-9, #4169E1)',
  'var(--chart-10, #DC143C)',
];

interface Props {
  data: Array<{ platform: string; count: number }>;
  title?: string;
}

export function PlatformPieChart({ data, title }: Props) {
  const { t } = useTranslation();
  const platformLabel = usePlatformLabel();

  if (data.length === 0) {
    return <div className={styles.empty}>{t('stats.noData')}</div>;
  }

  return (
    <div className={styles.chartCard}>
      <h3 className={styles.chartTitle}>{title ?? `${platformLabel} Distribution`}</h3>
      <div className={styles.chartWrap}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="count"
              nameKey="platform"
              cx="50%"
              cy="50%"
              innerRadius="35%"
              outerRadius="55%"
              paddingAngle={2}
              strokeWidth={0}
            >
              {data.map((_, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--text-primary)',
                fontSize: '0.75rem',
              }}
            />
            <Legend
              wrapperStyle={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
